import {
  VendorTaxonomyKey,
  BAR_SERVICES_TAXONOMY_KEY,
  CAKES_DESSERTS_TAXONOMY_KEY,
  HAIR_MAKEUP_TAXONOMY_KEY,
  BANDS_DJS_TAXONOMY_KEY,
} from '@zola-helpers/client/dist/es/marketplace/vendorTaxonomyKeys';
import { getVendorWordPlural } from '@zola-helpers/client/dist/es/marketplace/vendorWords';

const OVERRIDES: { [key in VendorTaxonomyKey]?: string } = {
  [BAR_SERVICES_TAXONOMY_KEY]: 'bar and beverage providers',
  [CAKES_DESSERTS_TAXONOMY_KEY]: 'cake and dessert providers',
  [HAIR_MAKEUP_TAXONOMY_KEY]: 'beauty pros',
  [BANDS_DJS_TAXONOMY_KEY]: 'bands and DJs',
};

export const getProviderWord = (taxonomyKey: VendorTaxonomyKey): string => {
  return OVERRIDES[taxonomyKey] || getVendorWordPlural(taxonomyKey);
};
